import { environment } from 'src/environments/environment';

const URL_SF_BASE_QA = 'https://wsqa.polpaicoconexion.cl/api/store-forward';
const URL_SF_BASE_PROD = 'https://ws.polpaicoconexion.cl/api/store-forward';

function getStoreForwardBaseUrl(): string {
  return environment.production ? URL_SF_BASE_PROD : URL_SF_BASE_QA;
}

export function getStoreForwardOperacionesUrl(): string {
  return `${getStoreForwardBaseUrl()}/operaciones`;
}

export function getStoreForwardIntentosUrl(): string {
  return `${getStoreForwardBaseUrl()}/operaciones/intentos`;
}

export function getStoreForwardConsultaUrl(): string {
  return `${getStoreForwardBaseUrl()}/operaciones/consulta`;
}

/** True si la URL pertenece al API de logs o store-forward (X-App-Key). */
export function isMonitoringGatewayRequest(url: string): boolean {
  return url.includes('/api/logs/') || url.includes('/api/store-forward/');
}
